import {Box, Button, ModalBody, ModalCloseButton, ModalContent, ModalFooter, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Modal} from 'components/shared';
import {IFilterType} from 'hooks';
import {useRouter} from 'next/router';
import {FC, PropsWithChildren, useEffect, useState} from 'react';
import {modalCloseButtonStyles, pinkScrollBarStyles} from 'theme';
import {TranslationKeys} from 'translations';
import {FilterListTypes, ICategoryByProviderResponse, ProviderTypeEnum} from 'types';

import {OptionsButtonsGroup} from '../subheaders/subheader-with-filters/components';
import {CategoryProductsFilters, TypeFilters} from './components';

interface Props {
  categories?: ICategoryByProviderResponse[];
  t: (term: TranslationKeys) => string;
  onChange: (filters: IFilterType) => void;
  providerType?: ProviderTypeEnum;
  typeList: {
    name: {en: string; ru: string; ro: string};
    label: string;
  }[];
  showFilters?: boolean;
}

export const FiltersModal: FC<PropsWithChildren<Props>> = ({
  providerType,
  onChange,
  t,
  categories,
  typeList,
  children,
  showFilters = true,
}) => {
  const {onClose, isOpen, onOpen} = useDisclosure();
  const {query} = useRouter();
  const [tempFilters, setTempFilters] = useState(query);

  useEffect(() => {
    if (query.promo) {
      setTempFilters((filters) => ({
        ...filters,
        filters: 'promo',
      }));
    } else {
      setTempFilters({...query});
    }
  }, [query]);

  const onHandleChangeFilters = (filters: IFilterType) => {
    onChange(filters);
  };

  const foo = ['promo', 'discount', 'delivery'];

  const onFilterActive = (value: FilterListTypes) => {
    // const isHasPromoValue = foo.includes(value) || !tempFilters.hasOwnProperty('promo');
    const isHasPromoValue = foo.includes(value);
    const filtersParam = tempFilters.filters !== value ? value : undefined;
    if (isHasPromoValue) {
      setTempFilters((filters) => ({
        ...filters,
        filters: 'promo',
        promo_type: value,
      }));
    } else {
      setTempFilters((filters) => ({
        ...filters,
        promo_type: undefined,
        filters: filtersParam,
      }));
    }
  };

  const handleCategoryClick = (categorySlug: string) => {
    setTempFilters((filters) => ({
      ...filters,
      categorySlug: tempFilters.categorySlug === categorySlug ? '' : categorySlug,
    }));
  };

  const resetFilters = () => {
    setTempFilters({});
    onHandleChangeFilters({});
    onClose();
  };

  const handleSubmit = () => {
    onHandleChangeFilters(tempFilters);
    onClose();
  };

  return (
    <>
      <Box onClick={onOpen}>{children}</Box>
      <Modal onClose={onClose} isOpen={isOpen}>
        <ModalContent
          maxW={['90%', '900px']}
          bg={colors.bodyBackground}
          maxH="80vh"
          my={['1vh', '5vh']}
          overflow="hidden"
          mt="5vh"
        >
          <ModalCloseButton mt="15px" sx={modalCloseButtonStyles} />
          <ModalBody p={0} overflowY="scroll" sx={pinkScrollBarStyles} bg={colors.white}>
            {categories && (
              <CategoryProductsFilters
                onChange={handleCategoryClick}
                t={t}
                categories={categories ?? []}
                providerType={providerType}
                activeCategory={tempFilters.categorySlug as string}
              />
            )}
            {showFilters && (
              <TypeFilters
                title={t('FILTERS_MORE')}
                onChange={onFilterActive}
                filtersList={tempFilters.promo_type ?? tempFilters.filters}
                typeList={typeList}
              />
            )}
          </ModalBody>
          <ModalFooter p={0}>
            <Box w="full" boxShadow="0px -1px 4px rgba(0, 0, 0, 0.1)" p="16px" bg="white">
              {query.filters || query.categorySlug || query.promo || query.promo_type ? (
                <OptionsButtonsGroup handleSubmit={handleSubmit} resetOrdering={resetFilters} t={t} />
              ) : (
                <Button variant="primary" w="100%" onClick={handleSubmit}>
                  {t('APPLY')}
                </Button>
              )}
            </Box>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
